import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { styled } from '@uhg-abyss/web/tools/styled';

export const StyledAccordionContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const StyledAccordionTrigger = styled(Accordion.Trigger, {
  border: 'none',
  boxShadow: 'none !important',
  dynamic: ({ isDisabled }) => {
    if (isDisabled) {
      return {
        backgroundColor: 'white !important',
        '&.abyss-icon-symbol': {
          display: 'none',
        },
      };
    }
    return {};
  },
});

export const StyledAccordionHeader = styled(Accordion.Header, {
  dynamic: ({ isError }) => {
    return {
      '.abyss-accordion-header-subtext': {
        color: isError ? '$error1' : 'black',
        'font-family': 'AbyssEnterpriseSansVF, Arial, sans-serif',
        fontWeight: 'normal',
      },
    };
  },
});

export const StyledTableRow = styled('tr', {
  borderBottom: '1px solid $gray4',
  borderTop: '1px solid $gray4',
  '&:hover': {
    backgroundColor: '$tint2',
  },
  cursor: 'pointer',
});

export const StyledTableDataCheckMarkColumn = styled('td', {
  padding: '8px 15px',
  verticalAlign: 'bottom',
});

export const StyledTableDataLabelColumn = styled('td', {
  padding: '8px 15px 8px 0px',
  'font-family': 'AbyssEnterpriseSansVF, Arial, sans-serif',
  color: 'black',
  fontSize: '16px',
  dynamic: ({ isSelectedRow }) => {
    return {
      fontWeight: isSelectedRow ? 'bold' : 'normal',
    };
  },
});

export const StyledTableDataBadgeColumn = styled('td', {
  padding: '8px 15px',
});

export const StyledErrorMessage = styled('span', {
  fontWeight: 'bold',
});
